import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    time: String,
    interval: { type: Number, default: 30000 } // 30 seconds default
  }

  connect() {
    this.updateTimestamp()
    this.startTimer()
  }

  disconnect() {
    this.stopTimer()
  }

  updateTimestamp() {
    const timestamp = new Date(this.timeValue)
    const now = new Date()
    const diff = Math.floor((now - timestamp) / 1000) // seconds

    this.element.textContent = this.formatTimeAgo(diff)
  }

  formatTimeAgo(seconds) {
    if (seconds < 30) return `< 30s ago`
    if (seconds < 60) return `< 60s ago`

    const minutes = Math.floor(seconds / 60)
    if (minutes === 1) return "1m ago"
    if (minutes < 60) return `${minutes}m ago`

    const hours = Math.floor(minutes / 60)
    if (hours === 1) return "1h ago"
    if (hours < 24) return `${hours}h ago`

    const days = Math.floor(hours / 24)
    if (days === 1) return "1d ago"
    if (days < 30) return `${days}d ago`

    const months = Math.floor(days / 30)
    if (months === 1) return "1M ago"
    if (months < 12) return `${months}M ago`

    const years = Math.floor(months / 12)
    return years === 1 ? "1y ago" : `${years}y ago`
  }

  startTimer() {
    this.timer = setInterval(() => {
      this.updateTimestamp()
    }, this.intervalValue)
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
